import { VISITOR_ID_PATTERN } from './constants.js';

/** Creates an RFC 9562 UUID v7 serialized as 32 lowercase hex characters. */
export function createVisitorId(now: number = Date.now()): string {
  if (!Number.isInteger(now) || now < 0 || now > 0xffffffffffff) {
    throw new Error('[Teo Widget] Invalid timestamp for visitor id');
  }
  if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
    throw new Error('[Teo Widget] crypto.getRandomValues required for visitor id');
  }

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  let timestamp = now;
  for (let index = 5; index >= 0; index -= 1) {
    bytes[index] = timestamp % 256;
    timestamp = Math.floor(timestamp / 256);
  }

  bytes[6] = (bytes[6]! & 0x0f) | 0x70;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const visitorId = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, '0'),
  ).join('');

  if (!VISITOR_ID_PATTERN.test(visitorId)) {
    throw new Error('[Teo Widget] Failed to generate visitor id');
  }

  return visitorId;
}
